export default class Floorplan {
    constructor() {
        this.init();
    }

    init() {
        //Get all pins
        var pins = document.querySelectorAll('.map .pin');
        //add click event to pins onClick
        pins.forEach(pin => {
            pin.addEventListener('click', (e) => {
                var id = e.target.id;
                if(!e.target.classList.contains('pin')){
                    id = e.target.parentElement.id;
                }

                this.onPinClick(id, pin);
            });
        });

        //Get all accordions
        var accordions = document.querySelectorAll('.accordion-list .ui-accordion');
        //add click event to accordions onClick
        accordions.forEach(accordion => {
            accordion.addEventListener('click', (e) => {
                this.onAccordionClick(e);
            });
        });

        // Init Draggable JQuery Widget
        $(".draggable").draggable({
            drag: function(evt, ui) {
                if (ui.position.top >= 0) {
                    ui.position.top = 0;
                }
    
                if (ui.position.left >= 0) {
                    ui.position.left = 0;
                }
    
                if (ui.position.left + evt.target.clientWidth <= evt.target.closest("div.map").clientWidth) {
                    ui.position.left = "";
                    ui.position.right = 0;
                }
    
                if (ui.position.top + evt.target.clientHeight <= evt.target.closest("div.map").clientHeight) {
                    ui.position.top = "";
                    ui.position.bottom = 0;
                }
            }
        });

        // Init Zoom
        var zoomPlusButton = document.querySelector(".zoom-map-plus");
        var zoomMinusButton = document.querySelector(".zoom-map-minus");
        var draggableElement = document.querySelector(".draggable");
  
        zoomPlusButton.addEventListener("click", () => {
          this.resize(1, draggableElement);
        });
  
        zoomMinusButton.addEventListener("click", () => {
          if (
            draggableElement.clientHeight >
              draggableElement.closest(".map").clientHeight &&
            draggableElement.clientWidth >
              draggableElement.closest(".map").clientWidth
          ) {
            draggableElement.style.top = "0";
            draggableElement.style.left = "0";
            this.resize(-1, draggableElement);
          }
        });
    }

    // map pins
    onPinClick(id, pin) {
        //Get all pins and set them to inactive
        var panels = document.querySelectorAll('.floorplan .panel');        

        //Activate the panel that matches the pin
        var panelToToggle = document.querySelector('.floorplan  #panel-' + id);
        var defaultPanel = document.querySelector('.floorplan  #panel-0');
        if(panelToToggle.classList.contains('active')){
            panelToToggle.classList.remove('active');
            defaultPanel.classList.add('active');
        }
        else{
            //Set all panels to inactive
            panels.forEach(panel => {
                panel.classList.remove('active');
            });
            panelToToggle.classList.add('active');
        }

        //remove active pin
        this.toggleActivePin(pin);       
    }

    //accordion
    onAccordionClick(e) {
        //Get all accordion items 
        var accordionItems = document.querySelectorAll('.accordion-list .ui-accordion');
        //Set all accordion items to inactive
        accordionItems.forEach(aI => {
            if(aI.classList.contains('active') && !(e.currentTarget.classList.contains('active'))){
                aI.classList.remove('active');
            }
        });

        // keep links clickable through the accordion
        let links = e.currentTarget.querySelectorAll('.link-block');
        links.forEach(link => {
            link.addEventListener("click", (e) => {
                e.stopPropagation();
            });
        })

        //Activate the accordion
        let accordiontoActivate = e.currentTarget;
        if(!(accordiontoActivate.classList.contains('active')))
        {
            accordiontoActivate.classList.add('active');
            
            let scrollableParentElement = document.querySelector(".panel.active"); 
            // scroll when css transform is finished
            setTimeout(() => {
                scrollableParentElement.scrollTo({
                    top: accordiontoActivate.offsetTop - 30,
                    behavior: 'smooth'
                }) 
            }, 250);
        }
        else{
            accordiontoActivate.classList.remove('active');
        }
    }


    toggleActivePin(pin){
        if(pin.classList.contains('pin-selected')){
            pin.classList.remove('pin-selected');
        }
        else{
            var activePin = document.querySelector('.pin-selected');
            activePin?.classList.remove('pin-selected');

            pin.classList.add('pin-selected');
        }        
    }

    resize(direction, element) {
        var ratio = element.clientWidth / element.clientHeight;
        var delta = 100 * direction;
  
        var positionInfo = element.getBoundingClientRect();
  
        element.style.width = positionInfo.width + delta * ratio + "px";
        element.style.height = positionInfo.height + delta + "px";
    };
}